import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/dashboard-container'
import { Box, CircularProgress } from '@mui/material'
import { marketDataService } from '../../utils/services/marketDataService'
import MarketDataList from '../../components/market-data-list'
import CustomPagination from '../../components/pagination'
import { useNavigate } from 'react-router-dom'

const MarketData = () => {
  const [selectedData, setSelectedData] = useState(null)
  const [openModal, setOpenModal] = useState(false)
  const [marketDataList, setMarketDataList] = useState([])
  const [viewMode, setViewMode] = useState('list')
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(15)
  const [dataCount, setDataCount] = useState(rowsPerPage)
  const [loading, setLoading] = useState(false)
  const clientId = localStorage.getItem('client_id')
  const navigate = useNavigate()
  const fetchMarketData = async () => {
    setLoading(true)
    try {
      const skip = page * rowsPerPage
      const response = await marketDataService.fetch(
        rowsPerPage,
        skip,
        clientId,
      )
      setMarketDataList(response.data)
      setLoading(false)
      setDataCount(response?.total)
    } catch (error) {
      console.error('Fetch failed:', error)
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchMarketData()
  }, [page, rowsPerPage])

  return (
    <>
      <DashboardContainer
        filterButton={false}
        hideUploadButton
        header={'Market Data'}
        title={'+ Market Data'}
        onClickAddButton={() => navigate('/manage-market-data/create')}
        setViewMode={setViewMode}
        hideFilterClient={true}
        onClickRefresh={() => fetchMarketData()}
      >
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 9999,
              color: 'white'
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <MarketDataList
            dataCount={dataCount}
            currentPage={page}
            itemsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setPage}
            onDeleteData={fetchMarketData}
            onEditData={(e) => {
              setSelectedData(e)
              setOpenModal(true)
            }}
            data={marketDataList}
            viewMode={viewMode}
            selectedDropskipTool={selectedData}
            setSelectedDropskipTool={setSelectedData}
          />
        )}
      </DashboardContainer>
      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
    </>
  )
}

export default MarketData
